/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoNftCarListRequest model module.
 * @module model/MonitoringControllerDtoNftCarListRequest
 * @version 1.0
 */
class MonitoringControllerDtoNftCarListRequest {
    /**
     * Constructs a new <code>MonitoringControllerDtoNftCarListRequest</code>.
     * @alias module:model/MonitoringControllerDtoNftCarListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MonitoringControllerDtoNftCarListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MonitoringControllerDtoNftCarListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoNftCarListRequest} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoNftCarListRequest} The populated <code>MonitoringControllerDtoNftCarListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoNftCarListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('account')) {
                obj['account'] = ApiClient.convertToType(data['account'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'Number');
            }
            if (data.hasOwnProperty('vehicleGrade')) {
                obj['vehicleGrade'] = ApiClient.convertToType(data['vehicleGrade'], 'String');
            }
            if (data.hasOwnProperty('vehicleSeal')) {
                obj['vehicleSeal'] = ApiClient.convertToType(data['vehicleSeal'], 'String');
            }
            if (data.hasOwnProperty('minLevel')) {
                obj['minLevel'] = ApiClient.convertToType(data['minLevel'], 'Number');
            }
            if (data.hasOwnProperty('maxLevel')) {
                obj['maxLevel'] = ApiClient.convertToType(data['maxLevel'], 'Number');
            }
            if (data.hasOwnProperty('isPlus')) {
                obj['isPlus'] = ApiClient.convertToType(data['isPlus'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoNftCarListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoNftCarListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MonitoringControllerDtoNftCarListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['account'] && !(typeof data['account'] === 'string' || data['account'] instanceof String)) {
            throw new Error("Expected the field `account` to be a primitive type in the JSON string but got " + data['account']);
        }
        // ensure the json data is a string
        if (data['vehicleGrade'] && !(typeof data['vehicleGrade'] === 'string' || data['vehicleGrade'] instanceof String)) {
            throw new Error("Expected the field `vehicleGrade` to be a primitive type in the JSON string but got " + data['vehicleGrade']);
        }
        // ensure the json data is a string
        if (data['vehicleSeal'] && !(typeof data['vehicleSeal'] === 'string' || data['vehicleSeal'] instanceof String)) {
            throw new Error("Expected the field `vehicleSeal` to be a primitive type in the JSON string but got " + data['vehicleSeal']);
        }

        return true;
    }


}

MonitoringControllerDtoNftCarListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MonitoringControllerDtoNftCarListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MonitoringControllerDtoNftCarListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MonitoringControllerDtoNftCarListRequest.prototype['skip'] = undefined;

/**
 * @member {String} account
 */
MonitoringControllerDtoNftCarListRequest.prototype['account'] = undefined;

/**
 * @member {Number} nftUid
 */
MonitoringControllerDtoNftCarListRequest.prototype['nftUid'] = undefined;

/**
 * @member {Number} vehicleType
 */
MonitoringControllerDtoNftCarListRequest.prototype['vehicleType'] = undefined;

/**
 * @member {String} vehicleGrade
 */
MonitoringControllerDtoNftCarListRequest.prototype['vehicleGrade'] = undefined;

/**
 * @member {String} vehicleSeal
 */
MonitoringControllerDtoNftCarListRequest.prototype['vehicleSeal'] = undefined;

/**
 * @member {Number} minLevel
 */
MonitoringControllerDtoNftCarListRequest.prototype['minLevel'] = undefined;

/**
 * @member {Number} maxLevel
 */
MonitoringControllerDtoNftCarListRequest.prototype['maxLevel'] = undefined;

/**
 * @member {Boolean} isPlus
 */
MonitoringControllerDtoNftCarListRequest.prototype['isPlus'] = undefined;






export default MonitoringControllerDtoNftCarListRequest;

